function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.3 24a11.864 11.864 0 01-9.8-6.1c-.1-.1-.1-.1-.1-.2a11.319 11.319 0 01-1.4-6v-.2a11.615 11.615 0 012-6c0-.1.1-.1.1-.2a11.828 11.828 0 019-5.1h1.4a12.03 12.03 0 0111.2 9.9.601.601 0 01-.1.4c-.1.1-.2.2-.3.2h-.1c-.2 0-.5-.2-.5-.4A8.515 8.515 0 0021.2 6h-4.5a24.543 24.543 0 01.8 2.9.548.548 0 01-.4.6H17c-.2 0-.5-.2-.5-.4a28.063 28.063 0 00-.8-3.1H8.3a14.37 14.37 0 00-1 5H11a.5.5 0 010 1H7.3a18.486 18.486 0 001 5h1.2a.5.5 0 010 1h-.8a27.793 27.793 0 003 5.2v.7c0 .1 0 0-.1.1h-.3zm-8.5-6a11.298 11.298 0 007.5 4.9A21.078 21.078 0 017.7 18zm4.5-1a18.486 18.486 0 01-1-5H1a10.843 10.843 0 001.2 5zm-1-6a14.37 14.37 0 011-5H2.8a9.978 9.978 0 00-1.7 5zm14.2-6A10.64 10.64 0 0014 1.2 14.837 14.837 0 0116.3 5zm-5.3 0a15.64 15.64 0 00-2.7-4h-1a20.098 20.098 0 00-2.7 4zM7.7 5A21.378 21.378 0 0110 1.2 10.92 10.92 0 003.5 5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 24a6.5 6.5 0 116.5-6.5 6.487 6.487 0 01-6.5 6.5zm0-12a5.5 5.5 0 105.5 5.5 5.549 5.549 0 00-5.5-5.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6 20.3a.616.616 0 01-.7-.1l-2-2a.495.495 0 11.7-.7l1.8 1.7 3.9-3.9a.495.495 0 11.7.7s-3.7 3.7-4.4 4.3z"
});

function SvgFormNetworkGood(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "formNetworkGood.e9827.svg";
export { SvgFormNetworkGood as ReactComponent };